import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TipState } from '../reducers';
import { selectCartTotals } from './cart.selectors';
import { selectWorkDay } from './work-day.selectors';
import { calculateTipList } from '@core/helpers';

export const selectTipState = createFeatureSelector<TipState>('tip');

export const selectTipLoading = createSelector(
  selectTipState,
  (state: TipState) => state.loading
);

export const selectTip = createSelector(
  selectTipState,
  (state: TipState) => state.tip
);

export const selectTipList = createSelector(
  selectTipState,
  (state: TipState) => state.tipList
);

export const selectTipError = createSelector(
  selectTipState,
  (state: TipState) => state.error
);

export const selectTipDetail = createSelector(
  selectTipState,
  (state: TipState) => state.tipDetail
);

export const selectTipDetails = createSelector(
  selectTip,
  (tip) => tip?.detallesPropinas ?? []
);

export const selectCalculatedTipList = createSelector(
  selectTipDetails,
  selectCartTotals,
  selectWorkDay,
  selectTipDetail,
  (tipDetails, cartTotals, workDay, activeTipDetail) => {
    const list = calculateTipList(tipDetails, cartTotals?.subtotal ?? 0n, workDay);
    const isCustom = !!activeTipDetail?.isCustom;

    const tips = list.map((tip) => ({
      ...tip,
      selected: !isCustom && (activeTipDetail?.idDetallePropina
        ? tip.idDetallePropina === activeTipDetail.idDetallePropina
        : tip.descripcion === activeTipDetail?.descripcion),
    }));

    const customTipItem = {
      percent: 0,
      value: isCustom ? (activeTipDetail?.value ?? 0) : 0,
      selected: isCustom,
      descripcion: 'Custom',
      isCustom: true,
    };

    const tipsList = [...tips, customTipItem];
    const selectedTip = isCustom ? customTipItem : tipsList.find((tip) => tip.selected) || null;

    return { tipsList, selectedTip };
  }
);
